// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__33rZ-","header":"ClearentDisclaimer_header__1aA6E","inner":"ClearentDisclaimer_inner__Amjde"};